import { render, staticRenderFns } from "./publicExport.vue?vue&type=template&id=5bfb9036&scoped=true"
import script from "./publicExport.vue?vue&type=script&lang=js"
export * from "./publicExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb9036",
  null
  
)

export default component.exports